export default {
  title: "我的工单",
  refresh: "刷新",
  create: "创建",
  id: "工单ID",
  type: "类型",
  status: "状态",
  createdAt: "创建时间",
  actions: "操作",
  detailTitle: "工单详情",
  email: "邮箱",
  description: "描述",
  response: "回复",
  noResponse: "暂无回复",
  statusPending: "待处理",
  statusResolved: "已解决",
  statusClosed: "已关闭",
};
